import React, {useEffect, useState} from 'react';
import {InternalPageRoot, PeerProfile_Internal_Panel} from "../../../index";
import {Modules, ShowViewType} from "../../../config/AppConfig";
import {getCurrUrlParamValue} from "../../../../common/fusion-ui/utils/ReactUtils";

const PeerProfile_Internal_Page = React.memo(({
                                                  open,
                                                  onHide,
                                                  showAs = ShowViewType.PAGE,
                                              }) => {
    const TAG = "PeerProfile_Internal_Page";
    const moduleName = Modules.PeerProfiles;

    const [recordId, setRecordId] = useState();

    useEffect(() => {
        const recordId = getCurrUrlParamValue('id');
        setRecordId(recordId);
    }, []);

    return (<>
            <InternalPageRoot
                tag={TAG}
                moduleName={moduleName}
                title={`Profile Details`}
                backToListText={'Back to profiles'}
                isDataFound={true}
                isDataLoading={false}
                showControls={false}
                open={open}
                onHide={onHide}
                showAs={showAs}>
                <PeerProfile_Internal_Panel
                    recordId={recordId}
                    fromPage={true}/>
            </InternalPageRoot>
        </>
    )
});
export default PeerProfile_Internal_Page;
